module.exports = __webpack_public_path__ + "static/media/site.767e435f.webmanifest";